import { ProductResponse } from "api/dtos/responses/shop/ProductResponse";
import { InstagramWidgetActEnum } from "./enum";
import { InstagramWidgetType } from "./model";
import { InstagramWidgetStatus, InstagramWidgetStoreModel } from "./state";
import { GetWidgetCountResponse } from "api/dtos/responses/shop/GetWidgetCountResponse";

const OnStep = (state: InstagramWidgetStoreModel, payload: number = 0) => {
  let copyState = state.Clone();
  copyState.step = payload;
  return copyState;
};

const OnGetTagProducts = (
  state: InstagramWidgetStoreModel,
  payload: ProductResponse[],
  isReplace = false
) => {
  let copyState = state.Clone();
  if (!isReplace) copyState.products = [...copyState.products, ...payload];
  else copyState.products = payload;
  return copyState;
};

const OnSetCount = (
  state: InstagramWidgetStoreModel,
  payload: GetWidgetCountResponse
) => {
  let copyState = state.Clone();
  copyState.count = payload.count;
  if (payload.needLoginUsers) {
    copyState.needLoginUsers = payload.needLoginUsers;
  }
  if (payload.itemGetmore) {
    copyState.itemGetmore = payload.itemGetmore;
  }

  if (payload?.needLoginAgain !== undefined) {
    copyState.needLoginAgain = payload?.needLoginAgain;
  }
  return copyState;
};

const OnChangeStatus = (
  state: InstagramWidgetStoreModel,
  status: InstagramWidgetStatus
) => {
  let copyState = state.Clone();
  copyState.status = status;
  return copyState;
};

const RiseSequenceNumber = (state: InstagramWidgetStoreModel) => {
  let copyState = state.Clone();
  copyState.sequenceNumber += 1;
  return copyState;
};

const SearchingVideos = (
  state: InstagramWidgetStoreModel,
  payload: boolean
) => {
  let copyState = state.Clone();
  copyState.workingSearch = payload;
  return copyState;
};

const InstagramWidgetReducer = (
  state: InstagramWidgetStoreModel = new InstagramWidgetStoreModel(),
  action: InstagramWidgetType
): InstagramWidgetStoreModel => {
  switch (action.type) {
    case InstagramWidgetActEnum.STEP:
      return OnStep(state, action.payload);
    case InstagramWidgetActEnum.GET_TAG_PRODUCTS:
      return OnGetTagProducts(state, action.payload, action.isReplace);
    case InstagramWidgetActEnum.COUNT:
      return OnSetCount(state, action.payload);
    case InstagramWidgetActEnum.CHANGE_STATUS:
      return OnChangeStatus(state, action.payload);
    case InstagramWidgetActEnum.RISE_SEQUENCENUMBER:
      return RiseSequenceNumber(state);
    case InstagramWidgetActEnum.SEARCHING:
      return SearchingVideos(state, action.payload);
    default:
      return state;
  }
};

export default InstagramWidgetReducer;
